import { get } from 'lodash'

import {
  VEHICLE_TYPE_CAR,
  VEHICLE_FUEL_ENERGY_TYPES,
  VEHICLE_CHARGEABLE_ENERGY_TYPES,
  VEHICLE_ENERGY_TYPE_ELECTRIC,
} from '../config/vehicles'

export const isVehicleInstalled = (vehicle) => get(vehicle, 'installed', false)

export const isVehicleCar = (vehicle) => {
  const vehicleType = get(vehicle, 'type', null)
  return vehicleType === VEHICLE_TYPE_CAR
}

export const isVehicleElectricCar = (vehicle) =>
  isVehicleCar(vehicle) && vehicle.energy_type === VEHICLE_ENERGY_TYPE_ELECTRIC

export const isVehicleChargeableCar = (vehicle) =>
  isVehicleCar(vehicle) && VEHICLE_CHARGEABLE_ENERGY_TYPES.includes(vehicle.energy_type)

export const isVehicleFuelCar = (vehicle) =>
  isVehicleCar(vehicle) && VEHICLE_FUEL_ENERGY_TYPES.includes(vehicle.energy_type)
